import React from 'react'

import HeaderPublic from '../../components/headerPublic/index.js'
import Footer from '../../components/footer/index.js'
import UserResetPassword from '../../components/userResetPassword/index.js'


const ResetPasswordUser = () => {

    return (
        <div>
            <HeaderPublic />

            <UserResetPassword />

            <Footer />
        </div>
    );
}

export default ResetPasswordUser;